import { render } from "./Logo.vue?vue&type=template&id=51be7a9a&scoped=true&ts=true"
import script from "./Logo.vue?vue&type=script&lang=ts"
export * from "./Logo.vue?vue&type=script&lang=ts"

import "./Logo.vue?vue&type=style&index=0&id=51be7a9a&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/atomic-design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51be7a9a"]])

export default __exports__